<template>
  <div>
    <header-sales></header-sales>

    <div id= "subheader"> </div>
    <div id= "main-container">
      <div id= "label-container">
        <span id="label">Nuevo Pedido</span>
      </div>
      <div id= "container">
        <div id="list-header-container">
          <input id="busqueda" type="text" placeholder="Búsqueda por código o nombre del producto" v-model="txtBusqueda" v-on:keyup="onKeyDownHandler">
          <div id= "seleccion-container" v-show="seleccion != 1">
            <span class="seleccion" @click="ckCategoria">{{nombreCategoria}}</span>
            <span class="seleccion" id="separador" v-show='nombreCategoria.length>0'>> </span>
            <span class="seleccion" @click="ckSubcategoria">{{nombreSubcategoria}}</span>
          </div>
        </div>
        <div id="list-container">
          <item-producto id="list-prod" v-for="item in items" :item='item' v-if="seleccion == 1 || seleccion == 2 || ((seleccion == 3 || seleccion == 4) && item.Precio)" @setItem="setSelection"></item-producto>
        </div>
      </div>
      <div id="btnContainer">
          <button id="btnAgregarPromo" @click="btnAgregarPromo" >AGREGAR PROMOS</button>
          <button id="btnCarrito" @click="btnCarrito" >IR AL CARRITO</button>
      </div>
    </div>


   <transition name="fadePro">
   <div v-show='seleccion==4' :seleccion='seleccion'>

     <div id='back-popup'>
     </div>

     <div id='popup'>

       <div id='popup-btnClose-container'>
        <img id='btnClose' v-on:click="btnCerrarPopup" src="/dist/btnClose.png" style="width: 20px;height: 20px">
       </div>

       <p id='popup-titulo'>Ver Producto</p>
       <div id='popup-container'>

         <div id='popup-image-container'>
           <img id='popup-image' :src="imagenProducto" >
         </div>

         <div id='popup-container-text'>
           <p id='popup-producto'>{{nombreProducto}}</p>
           <p id='popup-descripcion-producto'>{{descripcionProducto}}</p>
           <p id='popup-precio-unitario'>${{precioProducto | formatMoney}}</p>
           <span id='popup-cantidad-label'>CANTIDAD</span>
           <input :class='{popupCantidad:cantValida,popupCantidadInv:!cantValida}' type="text" value="1" v-model='cantidadProducto' v-on:keyup="updateCantidad">
           <div style="margin-top: 15px">
             <span id='popup-subtotal-label'>SUBTOTAL</span>
             <span id='popup-subtotal' style="font-size: 15px">${{cantidadProducto*precioProducto | formatMoney}}</span>
           </div>
         </div>

       </div>

       <div id="btnContainerPopup">
         <button  @click="btnCerrarPopup" id="btnCerrarPopup">CANCELAR</button>
         <button  @click="btnAgregar"     id="btnAgregarPopup">AGREGAR AL CARRITO</button>
       </div>

     </div>

   </div>
  </transition>


  </div>
</template>


<script>
  import axios from 'axios'
  import HeaderSales from '@components/views/header.vue';
  import ItemProducto from '@components/views/realizarPedido/itemRealizarPedido.vue';

  export default {
     name: 'RealizarPedido',
     components:{
      'header-sales': HeaderSales,
      'item-producto': ItemProducto,
     },
     data() {
       return {
        txtBusqueda:'',
        verBusqueda:false,
        seleccion:0,
        idCategoria:-1,
        idSubcategoria:-1,
        idProducto:-1,
        nombreCategoria:"",
        nombreSubcategoria:"",
        nombreProducto:"",
        descripcionProducto:"",
        precioProducto:0.0,
        cantidadProducto:1,
        subtotal:0.0,
        peso:0.0,
        archivoId:-1,
        cantValida:true,
        items: [],
        imagenProducto: null
       }
    },


    computed: {

      categorias() {
        return this.$store.state.pedido.categorias;
      },

      subcategorias() {
        return this.$store.state.pedido.subcategorias;
      },

      productos() {
        return this.$store.state.pedido.productos;
      }

    },


    methods: {

      getCategorias: function () {
       this.$store.commit('loader/start')
       axios.get('/WebSalesCategorias',{
          headers:{
                    Token:this.$store.state.user.token,
                    ClientSecret: process.env.CLIENT_SECRET,
                    EmpresaId: process.env.EMPRESA_ID
                  }
        }
        ).then((response) => {
            if (response.data.Code == 0)
            {
              this.$store.commit('pedido/saveCategorias',response.data.Categorias);
              this.getSubcategorias();
            }
            else if (response.data.Code == 99)
            {
               alert(response.data.Message)
               this.$router.push({name: 'login'});
            }
            else
            {
              alert(response.data.Message);
              console.log(">>code>>"+response.data.Code);
            }
        },(error) => {
          console.log(error)
          alert(error);
          })
      },



      getSubcategorias: function (idCat) {
        var url = '/WebSalesSubcategorias';
        axios.get(url,{
         headers:{
                   Token:this.$store.state.user.token,
                   ClientSecret: process.env.CLIENT_SECRET,
                   EmpresaId: process.env.EMPRESA_ID
                 }
         }
        ).then((response) => {
          this.$store.commit('loader/stop')
          if (response.data.Code == 0)
          {
            this.$store.commit('pedido/saveSubcategorias',response.data.Subcategorias);
            this.showItems();
          }
          else if (response.data.Code == 99)
          {
            alert(response.data.Message)
            this.$router.push({name: 'login'});
          }
          else
          {
            console.log(">>>>"+response.data.Message);
            alert(response.data.Message);
          }
      },(error) => {
        console.log(error)
        alert(error);
        })
      },


      onKeyDownHandler: function () {
        if (this.txtBusqueda.length > 1)
        {
          this.verBusqueda = true;
          this.seleccion = 3
          var reg = new RegExp(/^\d+$/);
          if (reg.test(this.txtBusqueda))
          {
            this.items = this.productos.filter((item) =>  {return item.Codigo == parseInt(this.txtBusqueda)});
          }
          else
          {
            this.items = this.productos.filter((item) =>  {return item.Nombre.toLowerCase().indexOf(this.txtBusqueda.toLowerCase()) !== -1});
          }
        }

        if(this.txtBusqueda.length == 0)
        {
          this.verBusqueda = false;
          this.seleccion=0;
          this.showItems();
        }
        this.$store.commit('pedido/setSeleccion',this.seleccion);
      },


      showItems : function () {
        if (this.seleccion == 0)
        {
           this.seleccion=1;
           this.$store.commit('pedido/setSeleccion',this.seleccion);
           this.items = [];
           this.items = this.categorias;
           this.items.map((e) => {
             e.showCheck = false;
             return e;
           })
        }
        else if (this.seleccion == 1)
        {
           this.seleccion=2;
           this.$store.commit('pedido/setSeleccion',this.seleccion);
           this.items = [];
            this.items = this.subcategorias.filter(item => {
              return item.CategoriaId == this.idCategoria
            })

            this.items = this.items.filter(s => {
              let count = this.productos.filter(p =>  (p.CategoriaId == s.CategoriaId && p.SubCategoriaId == s.Id))
              return count.length
            })

           this.items.map((e) => {
             e.showCheck = false;
             return e;
           })
        }
        else if (this.seleccion == 2)
        {
           this.seleccion=3;
           this.$store.commit('pedido/setSeleccion',this.seleccion);
           this.items = [];
           this.items = this.productos.filter((item) =>  {return item.CategoriaId == this.idCategoria  && item.SubCategoriaId == this.idSubcategoria});
           var carrito = this.$store.state.pedido.carrito
           this.items.map((e) => {
             var enCarrito = false;
             carrito.forEach((j)=> {
               if (e.Id === j.id)
               {
                  enCarrito = true
               }
             });
             e.showCheck = enCarrito;
             return e;
           })
        }
      },



      setSelection: function (id) {
        if (this.seleccion == 1)
        {
          this.idCategoria = id;
          var cat = this.items.find( item => item.Id === this.idCategoria);
          this.nombreCategoria = cat.Nombre;
          this.nombreSubcategoria = '';
          this.showItems();
        }
        else if (this.seleccion == 2)
        {
          this.idSubcategoria = id;
          var itemSubcategoria = this.items.find( item => item.Id === this.idSubcategoria);
          this.nombreSubcategoria = itemSubcategoria.Nombre;
          this.showItems();
        }
        else if (this.seleccion == 3)
        {
          var carrito = this.$store.state.pedido.carrito
          var enCarrito = false;
          carrito.forEach((j)=> {
            if (id === j.id)
              {
                enCarrito = true
              }
          });
          if (!enCarrito)
          {
            this.idProducto = id;
            var itemProducto = this.items.find( item => item.Id === this.idProducto);
            this.nombreProducto = itemProducto.Nombre;
            this.descripcionProducto = itemProducto.Nombre;
            this.precioProducto = itemProducto.Precio;
            this.cantidadProducto = 1;
            this.peso = itemProducto.EnvasePeso;
            this.archivoId = itemProducto.ArchivoId;
            if (this.archivoId != null)
            {
              var img = this.$store.state.pedido.imagenes.find( e => e.id === this.archivoId)
              if (img != null)
              {
                this.imagenProducto = img.image
              }
            }
            this.seleccion=4;
          }
          else
          {
            var obj = {
                       txt:'El producto seleccionado ya se encuentra en el carrito de compras, si desea agregar más unidades puede hacerlo desde allí',
                       txtBtnCancel:'No',
                       txtBtnOk:'Ir al carrito',
                       fCancel:null,
                       fOk:this.irAlCarrito
                      }
            this.$store.commit('popup/open',obj);
          }
        }
      },

      irAlCarrito() {
        this.$router.push({name: 'pedido'});
      },

      ckCategoria: function () {
        this.seleccion = 0;
        this.showItems();
      },

      ckSubcategoria: function () {
        this.seleccion = 1;
        this.showItems();
      },

      btnCerrarPopup: function () {
        this.seleccion = 3;
        this.idProducto = -1;
        this.nombreProducto = "";
        this.descripcionProducto = "";
        this.precioProducto = 0.0;
      },

      btnAgregar: function () {
        if (this.validar())
        {
          this.seleccion = 3;
          var nuevoProducto = {
            id: this.idProducto,
            idCategoria: this.idCategoria,
            idSubcategoria: this.idSubcategoria,
            producto: this.nombreProducto,
            descripcion: this.descripcionProducto,
            precio: this.precioProducto,
            cantidad: this.cantidadProducto,
            peso:this.peso,
            archivoId:this.archivoId,
            promocionId:0,
            tipoOblea:1
          };
          this.$store.commit('pedido/agregarAPedido',nuevoProducto);
        }
        else
        {
           var obj = {
                      txt:'El campo cantidad debe contener un valor numérico entero mayor a 0',
                      txtBtnCancel:'',
                      txtBtnOk:'Aceptar',
                      fCancel:null,
                      fOk:null
                     }
           this.$store.commit('popup/open',obj);
        }
      },


      updateCantidad: function() {
        var rex = new RegExp(/^\d+$/);
        if (rex.test(this.cantidadProducto))
        {
          if (this.cantidadProducto > 0)
          {
            this.cantValida = true
          }
          else
          {
            this.cantValida = false
          }
        }
        else
        {
          this.cantValida = false
        }
      },


      validar: function () {
        var rex = new RegExp(/^\d+$/);
        if (!rex.test(this.cantidadProducto))
        {
          return false;
        }
        else
        {
          if (this.cantidadProducto < 1)
          {
            return false;
          }
          else
          {
            return true;
          }
        }
      },

      btnAgregarPromo () {
      this.$router.push({name: 'promociones'});
      },

      btnCarrito () {
        this.$router.push({name: 'pedido'});
      },

    },

    mounted: function () {
      this.$store.commit('loader/stop')
      this.seleccion = 0;
      this.$store.commit('pedido/setSeleccion',this.seleccion);
      if ((this.categorias.length > 0) && (this.subcategorias.length > 0) && (this.productos.length > 0))
      {
         this.showItems();
      }
      else
      {
         this.getCategorias();
      }
    }

 }



</script>

<style scoped>




#back-popup{
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100vh;
background: #000000;
opacity: 0.6;
filter: alpha(opacity=60);
}



#popup{
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%,-50%);
width: 400px;
height: 350px;
border-radius: 15px;
box-sizing: border-box;
background: #ffffff;
border-style: solid;
border-width: 1px;
border: 1px solid #dddddd;
}


#popup-btnClose-container{
  display: flex;
  flex-direction:row;
  margin-top: 10px;
  height: 20px;
  padding-right: 10px;
  align-items: center;
  justify-content: flex-end;
  background:  #ffffff
}


#popup-titulo{
 font-size: 26px;
 color: #5C666F;
 text-align: center;
}


#popup-container{
  display: flex;
  flex-direction:row;
  width: 380px;
  height: 210px;
  background:  #ffffff

}

#popup-image-container{
  width: 160px;
  height: 150px;
  margin-top:35px;
  display: flex;
  justify-content: center;
  align-items: center;

}

#popup-image{
  max-width: 90%;
  max-height: 90%;
}


#popup-producto{
 margin-top: 45px;
 font-size: 15px;
 color: #5C666F;
 font-weight: bold;
}

#popup-descripcion-producto{
 margin-top: 6px;
 font-size: 11px;
 color: #5C666F;
}

#popup-precio-unitario{
 margin-top: 14px;
 margin-bottom: 20px;
 font-size: 24px;
 font-weight: 500;
 color: #5C666F;
}

#popup-cantidad-label{
 font-size: 12px;
 color: #5C666F;
 font-weight: 500;
}

#popup-subtotal-label{
 margin-top: 10px;
 font-size: 12px;
 color: #5C666F;
 font-weight: 500;
}



.popupCantidad{
 font-size: 12px;
 color: #5C666F;
 width: 40px;
 height:20px;
 margin-left: 80px;
 border-style: solid;
 border-radius: 5px;
 border:none;
 border-width: 1px;
 border: 1px solid #dddddd;
 text-align: center;
 outline: none;
}


.popupCantidadInv{
 font-size: 12px;
 color: #5C666F;
 width: 40px;
 height:20px;
 margin-left: 80px;
 border-style: solid;
 border-radius: 5px;
 border:none;
 border-width: 1px;
 border: 1px solid #ff0000;
 text-align: center;
 outline: none;
}


#popup-subtotal{
 font-size: 14px;
 margin-left: 80px;
 /*font-weight: 600;*/
 color: #5C666F;
}


#btnContainerPopup{
  height: 80px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}


#btnCerrarPopup{
  width: 100px;
  height: 40px;
  font-size: 10px;
  font-weight: bold;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 20px;
  border-style: solid;
  border:none;
  color: #4969B2;
  background: #ffffff;
  border-width: 1px;
  border: 1px solid #4969B2;
  outline: none;
}

#btnAgregarPopup{
  width: 160px;
  height: 40px;
  font-size: 10px;
  font-weight: bold;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 20px;
  border-style: solid;
  border:none;
  background: #44C7F4;
  color: #ffffff;
  outline: none;
}

#btnCerrarPopup:hover { cursor: pointer; }
#btnAgregarPopup:hover { cursor: pointer; }
#btnClose:hover { cursor: pointer; }



 #subheader {
 width: 100%;
 height: 35vh;
 background: linear-gradient(#005A9F , #1899D6);
 }


#main-container{
 position: absolute;
 top: 55vh;
 left: 50%;
 transform: translate(-50%,-50%);
 width: 700px;
 height: 85vh;
 }


#label-container{
  width: 700px;
  height: 10vh;
 }

#label{
  color:#ffffff;
  font-size: 27px;
 }


#container{
  width: 700px;
  height: 65vh;
  border-width: 1px;
  border: 1px solid #dddddd;
  box-sizing: border-box;
  background-color: #ffffff;
 }

#list-header-container{
  height: 13vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
 }

#busqueda{
 border-radius: 20px;
 width: 400px;
 margin-top:15px;
 padding-left: 40px;
 height:30px;
 border-style: solid;
 border:none;
 border-width: 1px;
 border: 1px solid #dddddd;
 color: #000000;
 outline: none;
 background: white url(/dist/icon-search.png) left no-repeat ;
 background-size: 25px 25px;
 background-position: 10px;
}

#seleccion-container{
 margin-top: 15px;
 display: flex;
 justify-content: center;
 align-items: center;
 background-color: #ffffff;
 }

.seleccion{
 color:#2292CD;
 font-weight: normal;
 margin-left:0 auto;
 margin-right: 0 auto;
 margin-top: 0px;
 font-size: 11px;
 font-weight: 500;
 text-align: center;
 }


.seleccion:hover{
    cursor: pointer;
  }


#separador{
 margin-left: 15px;
 margin-right: 15px;
 font-weight: 500;
 font-size: 13px;
 color:#dddddd;
 }


#list-container{
 width: 630px;
 height: 49vh;
 margin-top:0px;
 margin-left: 25px;
 margin-right: 25px;
 overflow: auto;
 background-color: #ffffff;
 }



#btnContainer{
  width: 660px;
  height: 10vh;
  display: flex;
  flex-direction:row;
  justify-content: flex-end;
  align-items: center;
 }


#btnAgregarPromo{
  width: 120px;
  height: 30px;
  font-size: 9px;
  margin-left: 5px;
  margin-right: 5px;
  border-style: solid;
  border:none;
  color: #4969B2;
  background: #ffffff;
  border-radius: 20px;
  border-width: 1px;
  border: 1px solid #4969B2;
  outline: none;
}


#btnCarrito{
  width: 100px;
  height: 30px;
  margin-left: 5px;
  margin-right: 5px;
  font-size: 9px;
  border-style: solid;
  border:none;
  background: #44C7F4;
  border-radius: 20px;
  color: #ffffff;
  outline: none;
}

#btnAgregarPromo:hover{cursor: pointer;}
#btnCarrito:hover{cursor: pointer;}

.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .25s;
}

.fade-enter-active {
  transition-delay: .25s;
}

.fade-enter, .fade-leave-active {
  opacity: 0}





.fadePro-enter {
  opacity: 0;
}
.fadePro-enter-active {
  transition: opacity 0.5s;
}
.fadePro-enter-to {
  opacity: 1;
}
.fadePro-leave {
  opacity: 1;
}
.fadePro-leave-active {
  transition: opacity 0.1s;
}
.fadePro-leave-to {
  opacity: 0;
}

/*-----------------------------------------------------------------------------------------------------------------------*/

/* width */
::-webkit-scrollbar {
    width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #dddddd;
    border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #cccccc;
    border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #bbbbbb;
}



::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #dddddd;
    opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #dddddd;
}

::-ms-input-placeholder { /* Microsoft Edge */
    color: #dddddd;
}



</style>



// WEBPACK FOOTER //
// src/components/views/realizarPedido/realizarPedido.vue